type LocalizedPlaceholder = Record<string, string>;

export type IPlaceHolder = {
  placeholderText?: {
    loggedIn: LocalizedPlaceholder;
    anonymous: LocalizedPlaceholder;
  }
  experimentCode: number;
  variation: 'control' | 'variant';
};

interface PlaceHolderProps extends Omit<IPlaceHolder, 'variation'> {
  firstName?: string;
  isLoggedIn: boolean;
  locale: string;
  placeholderIntl?: string;
  isLoading?: boolean;
}

export const getPlaceHolder = (
  {
    placeholderText, firstName, isLoggedIn, locale, placeholderIntl = '', isLoading = false,
  }: PlaceHolderProps,
): string => {
  const { loggedIn, anonymous } = placeholderText || {};

  if (isLoading) return '';

  const placeHolder = (isLoggedIn && firstName)
    ? loggedIn?.[locale]?.replace('userName', firstName)
    : anonymous?.[locale];

  return placeHolder || placeholderIntl;
};
